import React from 'react'

import NotificationItem from './NotificationItem'

const NotificationSection = ({ notificationSection }) => {
  const handleReadAll = () => {}

  const notificationsContent = notificationSection.notifications.map((notification) => {
    return <NotificationItem key={notification.id} notification={notification} />
  })

  return (
    <div className="w-full flex flex-col items-start">
      <div className="w-full flex items-center justify-between mb-[10px]">
        <h2 className="text-2xl font-bold text-[#F67443] font-Inter">{notificationSection.date}</h2>

        <button
          className="text-base font-medium text-[#F67443] underline font-Inter"
          onClick={handleReadAll}
        >
          Mark all as read
        </button>
      </div>

      <div className="w-full flex flex-col items-start gap-y-[10px]">{notificationsContent}</div>
    </div>
  )
}

export default NotificationSection
